import { JsonObject, JsonProperty } from 'json2typescript';
import { BaseObject } from './base-object-model';

@JsonObject('Pallet')
export class Pallet extends BaseObject {
  @JsonProperty('id', Number, true) id: number = undefined;
  @JsonProperty('supplierPalletId', String, true) supplierPalletId: string = undefined;
  @JsonProperty('height', Number, true) height: number = undefined;
}
